const orderId = {
	order: {
		title: "Kategori Order",
		subtitle: "Ringkasan daftar kategori order",
		label: "Order",
		empty_state: {
			title: "Tidak ada kategori order",
			description: "Silakan tambahkan kategori order baru.",
		},
		table: {
			title: "Data Kategori Order",
			columns: {
				date: "Tanggal",
				category: "Kategori",
				discount: "Diskon",
				status: "Status",
			},
		},
		status: {
			active: "Aktif",
			inactive: "Non Aktif",
		},
		forms: {
			add: {
				button: "Tambah Kategori Order",
				title: "Tambah Kategori Order",
				fields: {
					category: {
						label: "Kategori",
						placeholder: "Nama kategori",
					},
					discount: {
						label: "Diskon",
						placeholder: "Diskon",
					},
				},
				toast: {
					success: {
						title: "Berhasil!",
						description: "Berhasil memasukkan data kategori order baru!",
					},
					error: {
						title: "Terjadi Kesalahan",
						description: "Coba lagi beberapa saaat!",
					},
				},
			},
			edit: {
				title: "Edit Kategori Order",
				info: "Informasi kategori order",
				fields: {
					category: {
						label: "Kategori",
						placeholder: "kategori",
					},
					discount: {
						label: "Diskon",
						placeholder: "discount",
					},
				},
			},
			delete: {
				title: "Hapus Kategori Order",
				description: "Apakah kamu yakin ingin menghapus {name}?",
			},
		},
		actions: {
			cancel: "Batal",
			save: "Simpan",
			save_changes: "Simpan Perubahan",
			saving_changes: "Menyimpan...",
			delete: "Hapus",
		},
	},
};

export default orderId;
